import pageNextButton from '../page-next-button/page-next-button.vue';

export default{
    props: {
        userProfile: {
            type: Object,
            default: () => { return {} }
        },
        showPage: Boolean,
        scroller: Object
    },
    mounted() {
        this.showPageHandler();
    },
    watch: {
        showPage() {
            this.showPageHandler();
        }
    },
    methods: {
        nextHandler() {
            console.log('next page selected');
            this.$emit('next');
        },
        showPageHandler() {
            if (this.showPage && !this.scene) {
                this.initAnimation();
            }
        },
        initAnimation() {
            /* 'Override' this function in a page, e.g.

            this.scene = new ScrollMagic.Scene( {
                triggerElement: '#page-hoofdreden',
                duration: 400
            })
                .setPin('#page-hoofdreden')
                .addTo(this.scroller);

            */
        }
    },
    components: {
        pageNextButton
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/page.js